import React from 'react'
import Route from 'react-router/lib/Route'
import IndexRoute from 'react-router/lib/IndexRoute'

import App from 'containers/App'
import Login from 'containers/Auth/Login'
import Logout from 'containers/Auth/Logout'

import Admin from 'containers/Admin'
import Account from 'containers/Account'

import Manage from 'containers/Manage'
import Curriculums from 'containers/Manage/Curriculums'
import CurriculumsDefault from 'containers/Manage/Curriculums/default'
import CurriculumsShow from 'containers/Manage/Curriculums/show'
import PaymentSchemes from 'containers/Manage/PaymentSchemes'
import PaymentSchemesDefault from 'containers/Manage/PaymentSchemes/default'
import PaymentSchemesShow from 'containers/Manage/PaymentSchemes/show'

import Setup from 'containers/Setup'
import SetupDefault from 'containers/Setup/default'
import SetupColleges from 'containers/Setup/Colleges'
import SetupCourses from 'containers/Setup/Courses'
import SetupScholarships from 'containers/Setup/Scholarships'
import SetupOfferings from 'containers/Setup/Offerings'
import SetupOfferingsDefault from 'containers/Setup/Offerings/default'
import SetupOfferingsNew from 'containers/Setup/Offerings/new'
import SetupOfferingsShow from 'containers/Setup/Offerings/show'
import SetupOfferingsShowDefault from 'containers/Setup/Offerings/show-default'
import SetupOfferingsEdit from 'containers/Setup/Offerings/edit'

import Settings from 'containers/Settings'
import SettingsDefault from 'containers/Settings/default'
import SettingsSemester from 'containers/Settings/Semester'

import Print from 'containers/Print'
import PrintCurriculum from 'containers/Print/Curriculums'

import auth from 'containers/Admin/authentication'

export default function createRoutes(store) {
  return (
    <Route component={App}>
      <Route path="/login" component={Login} />
      <Route path="logout" component={Logout} onEnter={Logout.onEnter(store)} />
      <Route path="/" component={Admin} onEnter={auth(store)}>
        <Route path="account" component={Account} />
        <Route path="manage" component={Manage}>
          <Route path="curriculums" component={Curriculums}>
            <IndexRoute component={CurriculumsDefault} />
            <Route path=":id" component={CurriculumsShow} onEnter={CurriculumsShow.onEnter(store)} />
          </Route>
          <Route path="payment-schemes" component={PaymentSchemes}>
            <IndexRoute component={PaymentSchemesDefault} />
            <Route path=":id" component={PaymentSchemesShow} onEnter={PaymentSchemesShow.onEnter(store)} />
          </Route>
        </Route>
        <Route path="setup" component={Setup}>
          <IndexRoute component={SetupDefault} />
          <Route path="colleges" component={SetupColleges} onEnter={SetupColleges.onEnter(store)} />
          <Route path="courses" component={SetupCourses} onEnter={SetupCourses.onEnter(store)} />
          <Route path="scholarships" component={SetupScholarships} onEnter={SetupScholarships.onEnter(store)} />
          <Route path="offerings" component={SetupOfferings}>
            <IndexRoute component={SetupOfferingsDefault} />
            <Route path="new" component={SetupOfferingsNew} onEnter={SetupOfferingsNew.onEnter(store)} />
            <Route path=":id" component={SetupOfferingsShow} onEnter={SetupOfferingsShow.onEnter(store)}>
              <IndexRoute component={SetupOfferingsShowDefault} />
              <Route path="edit" component={SetupOfferingsEdit} />
            </Route>
          </Route>
        </Route>
        <Route path="settings" component={Settings}>
          <IndexRoute component={SettingsDefault} />
          <Route path="semester" component={SettingsSemester} />
        </Route>
      </Route>
      <Route path="print" component={Print}>
        <Route path="curriculums/:id" component={PrintCurriculum} />
      </Route>
    </Route>
  )
}



// WEBPACK FOOTER //
// ./src/routes.js